export const APP_VERSION = {
  commitHash: '29c0283',
  pushedAt: '2026-11-03 7:29 PM EST',
};
